// extracted by mini-css-extract-plugin
module.exports = {"chromeframe":"About_chromeframe__1-Ov9","main":"About_main__3a1iE"};